// Mock data for SEFER landing page

export const heroData = {
  eyebrow: "İSTANBUL · SEED ROUND",
  headline: "Türkiye'nin ilk\ndijital restoranı.",
  subheadline: "Ürün seçiminden kapıya ulaşana kadar — her adımda tek bir marka kalitesi.",
  backgroundImage: "https://images.unsplash.com/photo-1683827449087-ccf5a9e6283c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxkYXJrJTIwbW9vZHklMjBmb29kfGVufDB8fHx8MTc3MTM0ODAwOXww&ixlib=rb-4.1.0&q=85"
};

export const problemData = {
  label: "PROBLEM",
  headline: "Çok seçenek, çok soru,\naz güven.",
  problems: [
    {
      title: "Soğuk ve kötü lezzet",
      description: "30-45 dk bekleyince yemek soğuyor, lezzet gidiyor – SEFER Express ile 10-15 dk (hedef 12 dk), her zaman sıcak ve taze."
    },
    {
      title: "Yanlış veya eksik sipariş",
      description: "Yanlış ürün geliyor, unutuluyor, çözüm için saatlerce uğraşıyorsun – SEFER'de tek marka garantisiyle hata minimum, sorun anında çözülüyor."
    },
    {
      title: "Karar vermek yorucu",
      description: "Yüzlerce restoran, binlerce seçenek arasında kayboluyorsun – SEFER'de seçilmiş, sınırlı ve kaliteli menü; karar 30 saniye."
    },
    {
      title: "Yorumlara güvenememe",
      description: "Sahte yorumlar, şişirilmiş puanlar yüzünden sürekli risk alıyorsun – SEFER'de her ürün test edilmiş, gerçek kalite garanti."
    },
    {
      title: "Teslimat belirsizliği",
      description: "\"Ne zaman gelecek?\" sorusu bitmiyor, takip sistemi yetersiz kalıyor – SEFER'de tam kontrol, dakikası dakikasına tahmin ve takip."
    },
    {
      title: "Kötü müşteri hizmetleri",
      description: "Sorun çıktığında saatlerce bekleme, top çevirme veya yetersiz çözüm – SEFER'de doğrudan ve hızlı destek; sorunlar tek marka olarak anında halloluyor."
    }
  ],
  bottomLine: "Lezzet, kalite, güven, hız. Sefer standardı."
};

export const solutionData = {
  label: "NEDEN SEFER",
  headline: "Hızlı, güvenilir, lezzetli.",
  benefits: [
    {
      title: "10-15 Dakikada Kapında",
      description: "Express modeli ile hazır ürünler motor üzerinde bekliyor; 10-15 dakikada (hedef 12 dk) taze ve sıcak teslimat. Artık soğuk yemek veya uzun bekleme yok – her lokma anında lezzet."
    },
    {
      title: "Tek Marka, Tam Güven",
      description: "Marketplace kaosunda sahte yorum ve kalite belirsizliği yerine, SEFER'de her ürün seçilmiş, test edilmiş ve tek marka standardında. Güvenilirlik garanti, hayal kırıklığı sıfır."
    },
    {
      title: "Evinde Fine Dine Deneyimi",
      description: "Chef's Table ile haftada 2 gün ünlü şeflerin sınırlı porsiyonlu özel menüsü. Ev konforunda premium lezzet – yüksek beklenti, yüksek tatmin."
    },
    {
      title: "Dakikası Dakikasına Takip",
      description: "Tam kontrol lojistiğiyle teslimat süresi net tahmin ediliyor; takip sistemi kusursuz. \"Ne zaman gelecek?\" stresi tarih oluyor."
    },
    {
      title: "Karar Vermek Artık 30 Saniye",
      description: "Yüzlerce seçenek arasında kaybolma yerine, SEFER'de sınırlı ama özenle seçilmiş kaliteli menü. Karar yorgunluğu yok, doğrudan lezzete odaklan."
    },
    {
      title: "Sorun Çıktığında Anında Çözüm",
      description: "Kötü müşteri hizmetleri ve top çevirme yerine, tek marka olarak doğrudan hızlı destek. Sorunlar dakikalar içinde halloluyor – güvenin devamı garanti."
    }
  ],
  features: [
    {
      id: 1,
      number: "01",
      title: "EXPRESS",
      badge: "10–15 dk",
      description: "En sevilen ürünler, sıcaklık kontrollü mopedlerde teslime hazır. Hazırlanma süresi yok.",
      tags: "Hızlı ciro · Sıcak servis · Sıfır bekleme"
    },
    {
      id: 2,
      number: "02",
      title: "CHEF'S TABLE",
      badge: "Haftada 2 gün",
      description: "Haftada iki gün özel menü. Ünlü şeflerle iş birliği. Sınırlı porsiyon, yüksek beklenti.",
      tags: "Yüksek marj · Prestij · Marka değeri"
    }
  ],
  connector: "İki model. Tek marka. Sürdürülebilir bir restoran ekonomisi."
};

export const operationData = {
  label: "OPERASYON",
  headline: "Sıfır emisyon.\nTam kontrol.",
  subtext: "Dağıtım ağı tamamen SEFER'e ait. Her araç, her derece, her dakika.",
  features: [
    {
      id: 1,
      icon: "zap",
      title: "Sıfır Emisyon",
      description: "Yüzde yüz elektrikli moped filosu"
    },
    {
      id: 2,
      icon: "thermometer",
      title: "Sıcaklık Kontrolü",
      description: "Isıtmalı ve soğutmalı top-case"
    },
    {
      id: 3,
      icon: "package",
      title: "Hazır Stok",
      description: "Ürünler teslimat öncesi motorun üzerinde"
    },
    {
      id: 4,
      icon: "battery",
      title: "Batarya Swap",
      description: "Swap istasyonları — menzil sorunu yok"
    }
  ],
  connector: "Lojistik değil — marka deneyiminin parçası."
};

export const visionData = {
  label: "VİZYON",
  headline: "Şehrin en sevilen\ndijital restoranı olmak.",
  subtext: "SEFER çevrimiçi yemek deneyimini yeniden tanımladı. Sadece bir app değil — bir lezzet deneyimi.",
  stats: [
    { value: "₺180B+", label: "Türkiye yemek teslimat pazarı" },
    { value: "10-15 dk", label: "Express teslimat hedefi" },
    { value: "Fine Dine", label: "Evinizin konforunda, erişilebilir" }
  ]
};

export const productData = {
  label: "ÜRÜN",
  headline: "Tasarlandı. Kodlanıyor.",
  subtext: "Arayüz tamamlandı. İlk teslimat için yatırıma ihtiyacımız var.",
  footer: "UI/UX tamamlandı · Geliştirme son hız devam ediyor"
};

export const investmentData = {
  label: "YATIRIM",
  headline: "Detaylar pitch deck'te.",
  body: "Pazar analizi, finansal model, ekip bilgisi — hepsi hazır. Talep et, görüşelim.",
  footer: "48 saat içinde dönüş · Gizlilik garantili"
};

export const footerData = {
  brand: "SEFER",
  tagline: "Şehrin Dijital Restoranı",
  email: "info@seferyemek.com",
  copyright: "© 2025 SEFER · İstanbul"
};
